import { useContext, useEffect, useRef, useState } from "react";
import {
    useHistory,
    useParams,
    useLocation
} from "react-router-dom";
import Field from "./Field";
import { firestore } from "./firebase";
import { Prompt } from "react-router-dom";
import { UserContext } from "./providers/UserProvider";
import Section from "./Section";
import queryString from "query-string";
import { toast } from "react-toastify";

export default function Event() {
    const ref = useRef();

    const history = useHistory();
    const location = useLocation();

    const { user } = useContext(UserContext);

    const [queryParams, setQueryParams] = useState({});
    useEffect(() => setQueryParams(queryString.parse(location.search)), [location.search]);

    const { id } = useParams();

    const [data, setData] = useState({});
    const [event, setEvent] = useState(null);

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    
    useEffect(() => firestore.collection('events').doc(id).get().then(document => {
        if(document.exists) {
            setData(document.data());
        } else {
            setData({});
        }
        setEvent(document);
        ref.current.scrollTop = 0;
    }), [id]);
    
    const back = () => {
        if(!queryParams.return) return false;
        history.push(queryParams.return);
        return true;
    }

    const save = async () => {
        data.edited_by = user.uid;
        await firestore.collection('events').doc(id).set(data, { merge: true });
        setUnsavedChanges(false);
        toast.success("Änderungen wurden erfolgreich gespeichert", {theme: "dark"});
        back();
    };

    const shareImage = () => history.push(`/events/${id}/share`);

    const copyLink = () => {
        navigator.clipboard.writeText(`https://app.elgio.de/event/${id}`);
        toast.info("Eventlink in Zwischenablage kopiert", {theme: "dark"});
    };

    const remove = async () => {
        if(!window.confirm('Bist du dir sicher, dass du diesen Eintrag löschen willst?')) return;
        await firestore.collection('events').doc(id).delete();
        toast.success("Löschen erfolgreich", {theme: "dark"});
        if(!back())
            history.push('/events' + location.search);
    };

    return <div className="h-full flex flex-col">
        <Prompt message="Einige Änderungen wurden noch nicht gespeichert. Trotzdem fortfahren?" when={unsavedChanges} />
        <div className="bg-gray-500 flex flex-col md:flex-row gap-2 p-4 md:py-0 md:px-2">
            {queryParams.return && <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={back}>Zurück</button>}
            <button className="bg-blue-500 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold text-white" onClick={save}>Änderungen speichern</button>
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={shareImage}>Eventgrafik</button>
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={copyLink}>Eventlink kopieren</button>
            <button className="bg-gray-400 px-6 py-1 md:py-2 rounded md:rounded-b-none md:rounded-t md:mt-2 md:font-semibold" onClick={remove}>Event löschen</button>
        </div>
        {
            id && event ? <div className="p-3 overflow-scroll" key={event.id} ref={ref}>
                {event.data()?.story_link && <div className="mb-3 p-3 bg-gray-600 text-white rounded">
                    <div className="font-semibold">Für dieses Event wurde ein Story-Link gebucht.</div>
                    <div><a href={event.data().story_link} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">{event.data().story_link}</a></div>
                </div>}
                <Section title="Metadaten">
                    <div className="flex-col md:flex-row flex my-1">
                        <div className="w-64">ID:</div>
                        <div className="w-64">{id}</div>
                    </div>
                    <div className="flex-col md:flex-row flex my-1">
                        <div className="w-64">Erstellt am:</div>
                        <div className="w-64">{event?.data()?.created_timestamp?.toDate()?.toLocaleString('de-DE')}</div>
                    </div>
                    <div className="flex-col md:flex-row flex my-1">
                        <div className="w-64">Erstellt von:</div>
                        <div className="w-64">{event?.data()?.created_by === 'event_form' ? 'Event-Form' : 'Admin'}</div>
                    </div>
                    <div className="flex-col md:flex-row flex my-1">
                        <div className="w-64">Zuletzt bearbeitet von:</div>
                        <div className="w-64">{event?.data()?.edited_by === 'event_form' ? 'Event-Form' : 'Admin'}</div>
                    </div>
                </Section>
                <Section title="Daten" openDefault>
                    <Field name="Name" value={data?.name} onChange={(val) => setData({...data, ...{name: val}})} />
                    <Field name="Veranstalter" value={data?.organizers} type="array-text" onChange={(val) => setData({...data, ...{organizers: val}})} />
                    <Field name="Startzeitpunkt" value={data?.start} type="timestamp" onChange={(val) => setData({...data, start: val})} />
                    <Field name="Location" value={data?.location} onChange={(val) => setData({...data, ...{location: val}})} />
                    <Field name="Preis (in Euro)" value={data?.price} onChange={(val) => setData({...data, ...{price: Number(val)}})}/>
                    <Field name="Sticker-Link" value={data?.story_link} type="link" onChange={(val) => setData({...data, ...{story_link: val}})} />
                    <Field name="Lineup" value={data?.lineup} type="array-text" onChange={(val) => setData({...data, ...{lineup: val}})} />
                    <Field name="Bild" value={data?.image ? data.image : null} type="image" fileDirectory={`event_images/${id}`} onChange={(val) => setData({...data, ...{image: val}})} />
                </Section>
            </div> : <div className="p-3">
                Bitte warten...
            </div>
        }
    </div>;
}